<span class="chip"
      [class.chip--empty]="empty()"
      [class.chip--filled]="filled()">
  @switch (leading()) {
    @case ('avatar') {
    <span class="chip__avatar"
          [style.background-color]="avatarColor()">{{ avatarText() }}</span>
    }
    @case ('dot') {
    <span class="chip__dot"
          [style.background-color]="dotColor()"></span>
    }
    @case ('icon') {
    <mat-icon class="chip__icon">{{ icon() }}</mat-icon>
    }
  }
  <span class="chip__label">{{ label() }}</span>
</span>
